export const uomJsonObj = (values) => {
    try {
        const jsonObj = JSON.stringify({
            name: values?.name,
            valuetype: values?.valuetype?.value ?? null,
            stepQuantity: parseFloat(values?.stepQuantity),
            roundingRule: values?.roundingRule?.value ?? null,
        });
        return jsonObj;
    } catch (error) {
        console.error("Error building jsonObj:", error);
        return null;
    }
};
